import { SearchOutlined } from '@ant-design/icons';
import { theme } from 'antd';
import React, { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectDevices } from 'reduxStore/devices/selectors';
import { Badge, Button, Checkbox, Flex, Input, Select, Space } from 'zui/Antd';

const { useToken } = theme;

const FilterDevicesSelect = ({ selectedDevices, setSelectedDevices }) => {
	const devices = useSelector(selectDevices);

	const {
		token: { paddingXS, padding, borderRadiusOuter, colorTextDescription, colorPrimary }
	} = useToken();

	const [searchText, setSearchText] = useState('');

	// ✅ Filter devices based on search input
	const filteredDevices = useMemo(() => {
		return devices.filter((device) => device.name.toLowerCase().includes(searchText.toLowerCase()));
	}, [devices, searchText]);

	// ✅ Handle select/unselect device
	const handleCheckboxChange = (deviceID) => {
		const updatedSelection = selectedDevices.includes(deviceID)
			? selectedDevices.filter((id) => id !== deviceID)
			: [...selectedDevices, deviceID];

		setSelectedDevices(updatedSelection);
	};

	// ✅ Map devices to Select options with checkbox
	const options = filteredDevices.map((device) => ({
		label: device.name,
		value: device.deviceID,
		component: <Checkbox checked={selectedDevices.includes(device.deviceID)}>{device.name}</Checkbox>,
		onClick: () => handleCheckboxChange(device.deviceID)
	}));

	return (
		<Select
			mode='multiple'
			value={selectedDevices}
			onChange={setSelectedDevices}
			style={{ minWidth: 166 }}
			dropdownStyle={{ width: 322 }}
			placeholder='Devices'
			options={options}
			showSearch={false}
			prefix={
				selectedDevices.length > 0 && (
					<Badge
						count={selectedDevices.length}
						style={{
							backgroundColor: colorPrimary,
							borderRadius: borderRadiusOuter,
							marginRight: paddingXS
						}}
					/>
				)
			}
			dropdownRender={(menu) => (
				<Flex vertical style={{ borderRadius: borderRadiusOuter }}>
					<Flex
						justify='space-between'
						align='center'
						style={{
							padding
						}}
					>
						<Input
							placeholder='Search Devices'
							prefix={<SearchOutlined style={{ color: colorTextDescription }} />}
							value={searchText}
							onChange={(e) => setSearchText(e.target.value)}
							variant='borderless'
						/>
						<Button
							type='text'
							onClick={() => {
								setSelectedDevices([]);
								setSearchText('');
							}}
							style={{ padding: 0, textDecoration: 'underline' }}
						>
							Clear
						</Button>
					</Flex>
					{menu}
				</Flex>
			)}
			optionRender={(option) => <Space>{option.data.component}</Space>}
			tagRender={(props) => {
				const { value } = props;
				const firstSelectedDevice = devices.find((d) => d.deviceID === value);
				return firstSelectedDevice ? firstSelectedDevice.name : null;
			}}
			maxTagCount={1}
			menuItemSelectedIcon={null}
		/>
	);
};

export default FilterDevicesSelect;
